module.exports = __webpack_public_path__ + "static/media/phantom-dai-opera.960f08cf.png";